import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";

const Cookies = () => {
  useEffect(() => {
    window.scrollTo(0, -0);
  }, []);

  return (
    <Box component="main" className="main-page" sx={{ pt: 3, pb: 8 }}>
      <Typography gutterBottom color="textPrimary" variant="h3" mt={0} mb={5} >
        Política de Cookies
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        WWU MÉXICO, SOCIEDAD ANÓNIMA PROMOTORA DE INVERSIÓN DE CAPITAL
        VARIABLE (en adelante,“WWU”), utiliza en la página web
        http://www.WWU.com (en adelante, el“Sitio Web” o el “Portal”) y en las
        aplicaciones aplicaciones móviles WWU (en adelante, las
        “Aplicaciones”) dispositivos de almacenamiento de datos en equipos
        terminales (comúnmente denominados “cookies”). La presente política de
        cookies tiene por finalidad informarle de manera clara y precisa sobre
        las cookies que se utilizan en nuestro Sitio Web y en nuestras
        Aplicaciones. En su primera visita a nuestro Sitio Web y a nuestras
        Aplicaciones se le informa de la existencia de cookies y de la
        presente política de cookies. En futuras visitas puede consultar
        nuestra política en cualquier momento en la parte inferior del Sitio
        Web y en apartado Ajustes de las Aplicaciones “Política de Cookies”.
        Con su registro en el Sitio Web y en las Aplicaciones y/o la mera
        navegación por las mismas está consintiendo la instalación de las
        cookies de las que le informamos en la presente “Política de Cookies”
        (salvo que haya modificado la configuración de su navegador para
        rechazar cookies). Una cookie es un fichero que se descarga en el
        dispositivo del Usuario al acceder a determinados contenidos por
        páginas web, medios electrónicos y/o aplicaciones. Las cookies
        permiten a una aplicación o página web, entre otras cosas, almacenar y
        recuperar información sobre los hábitos de navegación de un Usuario o
        de su equipo y, dependiendo de la información que contengan y de la
        forma en que utilice su dispositivo, pueden utilizarse para reconocer
        al Usuario. Las cookies que WWU utiliza en el Sitio Web y las
        Aplicaciones son las siguientes: i. Cookies de sesión: Son un tipo de
        cookies diseñadas para recabar y almacenar datos mientras el Usuario
        accede a una página web o a una aplicación. ii. Cookies persistentes:
        Son un tipo de cookies en el que los datos siguen almacenados en el
        terminal y pueden ser accedidos y tratados durante un periodo definido
        por el responsable de la cookie, y que puede ir de unos minutos a
        varios años. iii. Cookies técnicas: permiten al Usuario la navegación
        a través de una página web o de una aplicación la utilización de las
        diferentes opciones o servicios que en ellas existen como, por
        ejemplo, controlar el tráfico y la comunicación de datos, identificar
        la sesión, o acceder a secciones de acceso restringido. iv. Cookies de
        análisis: Son aquéllas que bien tratadas por WWU o por terceros,
        permiten cuantificar el número de Usuarios y así realizar la medición
        y análisis estadístico de la utilización que hacen los Usuarios del
        servicio ofertado. Para ello se analiza su navegación en nuestra
        página web con el fin de mejorar la oferta de productos o servicios
        que le ofrecemos. v. Cookies de publicidad comportamental: Son
        aquéllas que permiten la gestión, de la forma más eficaz posible, de
        los espacios publicitarios que, en su caso, el editor haya incluido en
        una página web, aplicación o plataforma desde la que presta el
        servicio solicitado. Estas cookies almacenan información del
        comportamiento de los Usuarios obtenida a través de la observación
        continuada de sus hábitos de navegación, lo que permite desarrollar un
        perfil específico para mostrar publicidad en función del mismo.
        Asimismo es posible que al visitar alguna página web o al abrir algún
        email o una aplicación donde se publique algún anuncio o alguna
        promoción sobre los productos o servicios de WWU se instale en el
        navegador del Usuario alguna cookie que le sirva a la sociedad para
        mostrarle posteriormente publicidad relacionada con la búsqueda que
        haya realizado, desarrollar un control de los anuncios en relación,
        por ejemplo, con el número de veces que son vistos, donde aparecen, a
        qué hora se ven, etc. Los tipos de cookies definidos y que utiliza WWU
        en su Sitio Web y en sus Aplicaciones son cookies propias y de
        tercero. Cookies propias: -Nombre: PHPSESSID -Descripción y finalidad:
        Cookie de sesión -Tipo: Técnico -Tipo por su duración: De sesión
        Cookies de terceros: -Nombre: _ga -Descripción y finalidad: Google
        Analytics -Tipo: Analítica web -Tipo por su duración: Persistente
        -Nombre: _dc_gtm_UA-66872089-3 -Descripción y finalidad: Google
        Analytics con funcionalidades de advertising -Tipo: Perfilación -Tipo
        por su duración: Persistente En los siguientes enlaces puede consultar
        la política de cookies de cada una de estas entidades: i. Google
        Analytics y Youtube, consultar los siguientes enlaces:
        https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage
        https://www.google.com/analytics/learn/privacy.html
        http://www.google.com/intl/en-US/policies/technologies/cookies/ ii.
        Twitter, consultar el siguiente enlace: https://twitter.com/privacy
        iii. Addthis, consultar el siguiente enlace:
        http://www.addthis.com/privacy
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        Revocación y eliminación de cookies
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        El Usuario puede permitir, bloquear o eliminar las cookies instaladas
        en su equipo mediante la configuración de las opciones del navegador
        instalado en su ordenador o en su dispositivo móvil. Estos
        procedimientos están sometidos a actualización o modificación por
        parte de los desarrolladores de los navegadores, por lo que no podemos
        garantizar que se ajusten completamente a la última versión disponible
        en cada momento. En caso que no permita la instalación de cookies en
        su navegador es posible que no pueda acceder a alguno de los sevicios
        y secciones de la web o de las aplicaciones de WWU. Para más
        información sobre configuración de cookies de Internet Explorer pulse
        aquí. Para más información sobre configuración de cookies de Google
        Chrome pulse aquí. Para más información sobre configuración de cookies
        de Firefox pulse aquí. Para más información sobre configuración de
        cookies de Safari pulse aquí. Para más información sobre configuración
        de cookies de Opera pulseaquí. Alternativamente, estaguía online
        contiene información exhaustiva sobre cómo realizar esto en una gran
        variedad de navegadores. El enlace contiene más información sobre cómo
        eliminar las cookies del equipo así como información más general sobre
        las cookies. Si tiene dudas sobre esta política de cookies, puede
        encontrar información en https://oneservice.mx/mx/privacy o contactar
        con WWU por correo electrónico a info@oneservice.mx. Consentimiento El
        Usuario puede retirar su consentimiento previamente otorgado a la
        instación de cookies en cualquier momento eliminando las cookies
        instaladas en su equipo mediante la configuración de las opciones del
        navegador, tal como se indica en el apartado 'revocación y eliminación
        de cookies'. No obstante, ello puede impactar en las funcionalidades
        de la web, haciendo la experiencia del Usuario menos satisfactoria.
      </Typography>
    </Box>
  );
};

export default Cookies;
